import { api } from "./client";

export type AddressDevice = {
  kind: "computer" | "printer";
  id: string;
  name: string;
  ip: string;
  mac: string;
  connection: string;
  /** true: the router hands it out (reserve it); false: typed into Windows; null: unknown. */
  assigned_by_router: boolean | null;
  changed_recently: boolean;
  /** false for PCs whose KraetdNet hasn't reported its network yet. */
  reported: boolean;
};

export type FixedAddresses = {
  router: string;
  devices: AddressDevice[];
};

export async function getFixedAddresses() {
  const { data } = await api.get<FixedAddresses>("/fixed-addresses/");
  return data;
}
